import axios from "@/api/axiosInstance";
import { UpdateProcessWheelRequest, UpdateProcessWheelResponse } from "./types";

export const updateProcessWheel = async (
  uuid: string,
  requestData: UpdateProcessWheelRequest,
): Promise<UpdateProcessWheelResponse> => {
  const response = await axios.put<UpdateProcessWheelResponse>(
    `/api/private/admin/process-wheels/${uuid}`,
    requestData,
  );
  return response.data;
};
